<script>
import CookieModal from '../../../../main/vue/cookies/components/CookieModal.vue'

export default {
  name: 'CookieModal',
  extends: CookieModal
}
</script>
